import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateClassRoomService=async(data)=>{
    try {
        const result = await post(`api/admin/class_room/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClassRoomService=async(data,id)=>{
    try {
        const result = await put(`api/admin/class_room/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassRoomService=async(page,search,from_date,to_date)=>{
    try {
        const result = await get(`api/admin/class_room/get?page=${page}&text=${search}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClassRoomService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/class_room/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

